import { MenuItemType } from "@arelia-components/ui-atoms/menu-selector/models";
import SortIcon from '@mui/icons-material/Sort';
import { FansSorting, SortOrderMap as SortOrderMapType, SortValueGetterMap as SortValueGetterMapType } from "./models";
import { SortOrder } from "@arelia-types/data-models";
import SortMenuLabel from "@arelia-components/ui-atoms/SortMenuLabel";
import { ColumnDef } from "@arelia-components/ui-atoms/data-grid";

export const sortByMenu: MenuItemType<FansSorting>[] = [{
  label: <SortMenuLabel><SortIcon sx={{ transform: "scaleY(-1)" }} />Latest first</SortMenuLabel>,
  value: FansSorting.createdDateDesc
}, {
  label: <SortMenuLabel><SortIcon/>Oldest first</SortMenuLabel>,
  value: FansSorting.createdDateAsc
}, {
  label: <SortMenuLabel><SortIcon sx={{ transform: "scaleY(-1)" }} />Name A-Z</SortMenuLabel>,
  value: FansSorting.nameAsc
}, {
  label: <SortMenuLabel><SortIcon />Name Z-A</SortMenuLabel>,
  value: FansSorting.nameDesc
}];

export const SortOrderMap: SortOrderMapType = {
  [FansSorting.createdDateAsc]: SortOrder.asc,
  [FansSorting.createdDateDesc]: SortOrder.desc,
  [FansSorting.nameAsc]: SortOrder.asc,
  [FansSorting.nameDesc]: SortOrder.desc
};

export const SortValueGetterMap: SortValueGetterMapType = {
  [FansSorting.createdDateAsc]: fan => new Date(fan.createdAt),
  [FansSorting.createdDateDesc]: fan => new Date(fan.createdAt),
  [FansSorting.nameAsc]: fan => fan.fullName?.trim().toLowerCase() || "\ufff0",
  [FansSorting.nameDesc]: fan => fan.fullName?.trim().toLowerCase() || "\ufff0"
};

export const API_ROUTE = "/api/my-fans/fans";

export const fansColumnConfig: ColumnDef[] = [{
  field: "fullName",
  headerName: "Name",
  width: "20%",
  editable: true,
},{
  field: "email",
  headerName: "Email",
  width: "20%",
  editable: true,
}, {
  field: "phone",
  headerName: "Phone",
  width: "15%",
  editable: true,
}, {
  field: "country",
  headerName: "Country",
  width: "15%",
  editable: true,
},{
  field: "city",
  headerName: "City",
  width: "15%",
  editable: true,
},{
  field: "createdAt",
  headerName: "Created",
  width: "15%",
  editable: false,
  type: "date"
}];

export const FANS_UPDATE_EVENT_NAME = "fansUpdated";
